var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[(_vm.myRoute === 'send')?_c('Send',{attrs:{"msg":_vm.msg}}):_vm._e(),(_vm.myRoute === 'redirect')?_c('Redirect'):_vm._e(),(_vm.myRoute === 'statistic')?_c('LongRedirect'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }